export default {
  obligatory: 'Поле є обов’язковим для заповнення',
  emptyDateBirthday: 'Необхідно ввести дату народження',
  emptyInn: 'Необхідно ввести ІПН',
  smallInn: 'ІПН складається з 10 цифр',
  emptyCountUtr: 'Необхідно вказати кількість утриманців',
  serialPassport: 'Серія не з 2-х літер',
  numberPassport: 'Номер повинен бути з 6 цифр',
  numberIdCard: 'Номер повинен бути з 9 цифр',
  dateDocument: 'Необхідно заповнити дату',
  errorFormatDate: 'Перевірте правильність вводу дати',
  emptyWorkExpiriens: 'Необхідно вказати стаж',
  emptyAvgIncome: 'Необхідно вказати дохід',
  minSummCredit: 'Сума не може бути менше 1000 грн',
  maxSummCredit: 'Сума не може бути більшою за 300000 грн',
  incorrect: 'Введіть коректне значення'
}